import {GenericList} from './GenericList';
import {CustomerFinances} from "../../models/CustomerFinances";

export class CustomerFinancesList extends GenericList<CustomerFinances> {}
